import React, { useState, Component } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LogOut, User, Building2, Camera, Upload, Instagram, Twitter, Facebook, Youtube, ChevronRight, ChevronLeft, Check, Shield, BookOpen, BarChart3, Share2, FileText, FileUp, Info, AlertCircle, File, FileType, Tablet, Book } from 'lucide-react';
export function OnboardingPage() {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [uploadSubStep, setUploadSubStep] = useState(1);
  const [formData, setFormData] = useState({
    role: '',
    profileImage: null,
    profession: '',
    specialization: '',
    bio: '',
    instagram: '',
    twitter: '',
    facebook: '',
    youtube: '',
    // Nuovi campi per il caricamento dell'opera
    uploadMethod: '',
    bookFile: null,
    bookTitle: '',
    bookPages: '',
    bookGenre: '',
    bookDescription: '',
    bookCover: null,
    originalityDeclaration: false,
    aiUsed: false,
    aiType: '',
    aiPercentage: ''
  });
  // Function to handle form data changes
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  // Function to handle role selection
  const handleRoleSelect = role => {
    setFormData(prev => ({
      ...prev,
      role
    }));
  };
  // Function to handle upload method selection
  const handleUploadMethodSelect = method => {
    setFormData(prev => ({
      ...prev,
      uploadMethod: method
    }));
  };
  // Function to handle file upload for profile image
  const handleImageUpload = e => {
    // In a real app, you would handle file upload to a server
    // For this demo, we'll just store the file object
    if (e.target.files && e.target.files[0]) {
      setFormData(prev => ({
        ...prev,
        profileImage: URL.createObjectURL(e.target.files[0])
      }));
    }
  };
  // Function to handle file upload for book file
  const handleBookFileUpload = e => {
    if (e.target.files && e.target.files[0]) {
      setFormData(prev => ({
        ...prev,
        bookFile: e.target.files[0]
      }));
    }
  };
  // Function to handle file upload for book cover
  const handleBookCoverUpload = e => {
    if (e.target.files && e.target.files[0]) {
      setFormData(prev => ({
        ...prev,
        bookCover: URL.createObjectURL(e.target.files[0])
      }));
    }
  };
  // Function to navigate to next step
  const nextStep = () => {
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1);
    } else {
      // If we're in the upload step, handle sub-steps
      if (currentStep === 4) {
        if (uploadSubStep < 3) {
          setUploadSubStep(uploadSubStep + 1);
        } else {
          // Complete onboarding and redirect to dashboard
          navigate('/dashboard');
        }
      }
    }
  };
  // Function to navigate to previous step
  const prevStep = () => {
    if (currentStep > 1) {
      if (currentStep === 4 && uploadSubStep > 1) {
        // If we're in the upload step, handle sub-steps
        setUploadSubStep(uploadSubStep - 1);
      } else {
        setCurrentStep(currentStep - 1);
      }
    }
  };
  // Function to exit onboarding
  const exitOnboarding = () => {
    if (window.confirm('Sei sicuro di voler uscire? I tuoi dati non saranno salvati.')) {
      navigate('/login');
    }
  };
  // Check if current step is valid to proceed
  const isStepValid = () => {
    switch (currentStep) {
      case 1:
        return formData.role !== '';
      case 2:
        return formData.profession !== '' && formData.bio !== '';
      case 3:
        // Social media is optional, so always valid
        return true;
      case 4:
        // Check sub-steps for upload
        switch (uploadSubStep) {
          case 1:
            return formData.uploadMethod !== '' || formData.bookFile !== null;
          case 2:
            return formData.bookTitle !== '' && formData.bookGenre !== '' && formData.bookDescription !== '';
          case 3:
            return formData.originalityDeclaration;
          default:
            return false;
        }
      default:
        return false;
    }
  };
  return <div className="min-h-screen bg-[#376770] flex flex-col" data-id="element-769">
      {/* Navbar with integrated step bar */}
      <nav className="h-16 md:h-20 border-b border-[#7F9EA4]/50 flex items-center px-4 sm:px-6 lg:px-8" data-id="element-770">
        <div className="flex items-center" data-id="element-771">
          <Link to="/" className="flex items-center" data-id="element-772">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jJkprGARCzfGvbLTaJLb3b/Elze_logo.svg" alt="Elze Logo" className="h-10 w-auto filter brightness-0 invert-[1]" data-id="element-773" />
          </Link>
        </div>
        {/* Step Bar - now in the center of navbar */}
        <div className="flex-1 flex justify-center" data-id="element-774">
          <div className="hidden sm:flex items-center" data-id="element-775">
            <StepIndicator number={1} title="Ruolo" active={currentStep >= 1} completed={currentStep > 1} data-id="element-776" />
            <div className="w-8 h-1 bg-[#7F9EA4]/50 mx-1" data-id="element-777">
              <div className={`h-full ${currentStep > 1 ? 'bg-white' : 'bg-[#7F9EA4]/50'}`} data-id="element-778"></div>
            </div>
            <StepIndicator number={2} title="Informazioni" active={currentStep >= 2} completed={currentStep > 2} data-id="element-779" />
            <div className="w-8 h-1 bg-[#7F9EA4]/50 mx-1" data-id="element-780">
              <div className={`h-full ${currentStep > 2 ? 'bg-white' : 'bg-[#7F9EA4]/50'}`} data-id="element-781"></div>
            </div>
            <StepIndicator number={3} title="Social" active={currentStep >= 3} completed={currentStep > 3} data-id="element-782" />
            <div className="w-8 h-1 bg-[#7F9EA4]/50 mx-1" data-id="element-783">
              <div className={`h-full ${currentStep > 3 ? 'bg-white' : 'bg-[#7F9EA4]/50'}`} data-id="element-784"></div>
            </div>
            <StepIndicator number={4} title="Carica Opera" active={currentStep >= 4} completed={false} data-id="element-785" />
          </div>
          {/* Mobile step indicator - just shows current step */}
          <div className="sm:hidden text-white" data-id="element-786">
            <span className="font-medium" data-id="element-787">Passo {currentStep}</span>
            <span className="text-gray-400 mx-1" data-id="element-788">/</span>
            <span className="text-gray-400" data-id="element-789">4</span>
            {currentStep === 4 && <>
                <span className="text-gray-400 mx-1" data-id="element-790">-</span>
                <span className="font-medium" data-id="element-791">
                  Sottopasso {uploadSubStep}/3
                </span>
              </>}
          </div>
        </div>
        <button onClick={exitOnboarding} className="flex items-center text-gray-300 hover:text-white transition-colors" data-id="element-792">
          <LogOut size={18} className="mr-2" data-id="element-793" />
          <span className="text-sm font-medium" data-id="element-794">Esci</span>
        </button>
      </nav>
      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-y-auto pb-20" data-id="element-795">
        <div className="max-w-3xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8 flex-1" data-id="element-796">
          {/* Step 1: Role Selection */}
          {currentStep === 1 && <div className="flex-1 flex flex-col" data-id="element-797">
              <div className="text-center mb-8" data-id="element-798">
                <h2 className="text-2xl font-bold text-white mb-2" data-id="element-799">
                  Seleziona il tuo ruolo
                </h2>
                <p className="text-gray-300" data-id="element-800">
                  Scegli il ruolo che meglio rappresenta la tua attività su Elze
                </p>
              </div>
              <div className="bg-white rounded-lg p-6 mb-6 shadow-lg" data-id="element-801">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-802">
                  <RoleCard icon={<User size={32} data-id="element-804" />} title="Autore" description="Scrivi e pubblica le tue opere, gestisci i diritti d'autore e monitora le royalties" selected={formData.role === 'autore'} onClick={() => handleRoleSelect('autore')} data-id="element-803" />
                  <RoleCard icon={<Building2 size={32} data-id="element-806" />} title="Editore" description="Scopri nuovi talenti, acquisisci diritti e gestisci il catalogo delle pubblicazioni" selected={formData.role === 'editore'} onClick={() => handleRoleSelect('editore')} data-id="element-805" />
                </div>
              </div>
            </div>}
          {/* Step 2: Personal Information */}
          {currentStep === 2 && <div className="flex-1 flex flex-col" data-id="element-807">
              <div className="text-center mb-8" data-id="element-808">
                <h2 className="text-2xl font-bold text-white mb-2" data-id="element-809">
                  Informazioni personali
                </h2>
                <p className="text-gray-300" data-id="element-810">
                  Completa il tuo profilo per farti conoscere dalla community
                </p>
              </div>
              <div className="bg-white rounded-lg p-6 mb-6 shadow-lg" data-id="element-811">
                <div className="flex flex-col sm:flex-row items-center gap-6 mb-6" data-id="element-812">
                  <div className="relative" data-id="element-813">
                    <div className="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden" data-id="element-814">
                      {formData.profileImage ? <img src={formData.profileImage} alt="Profile" className="w-full h-full object-cover" data-id="element-815" /> : <User size={40} className="text-gray-400" data-id="element-816" />}
                    </div>
                    <label htmlFor="profile-image" className="absolute bottom-0 right-0 w-8 h-8 bg-[#376770] rounded-full flex items-center justify-center cursor-pointer border border-[#7F9EA4] hover:bg-[#164149] transition-colors" data-id="element-817">
                      <Camera size={16} className="text-white" data-id="element-818" />
                    </label>
                    <input type="file" id="profile-image" className="hidden" accept="image/*" onChange={handleImageUpload} data-id="element-819" />
                  </div>
                  <div className="flex-1" data-id="element-820">
                    <h3 className="text-gray-800 font-medium mb-1" data-id="element-821">
                      Immagine profilo
                    </h3>
                    <p className="text-gray-500 text-sm" data-id="element-822">
                      Carica un'immagine che ti rappresenti. Consigliamo un
                      formato quadrato.
                    </p>
                  </div>
                </div>
                <div className="space-y-4" data-id="element-823">
                  <div data-id="element-824">
                    <label htmlFor="profession" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-825">
                      Professione
                    </label>
                    <input type="text" id="profession" name="profession" value={formData.profession} onChange={handleChange} className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-2 text-gray-800 focus:ring-2 focus:ring-[#376770]/20 focus:border-[#376770] focus:outline-none" placeholder="Es. Scrittore, Editore, Giornalista" data-id="element-826" />
                  </div>
                  <div data-id="element-827">
                    <label htmlFor="specialization" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-828">
                      Specializzazione
                    </label>
                    <input type="text" id="specialization" name="specialization" value={formData.specialization} onChange={handleChange} className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-2 text-gray-800 focus:ring-2 focus:ring-[#376770]/20 focus:border-[#376770] focus:outline-none" placeholder="Es. Narrativa, Poesia, Saggistica" data-id="element-829" />
                  </div>
                  <div data-id="element-830">
                    <label htmlFor="bio" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-831">
                      Biografia
                    </label>
                    <textarea id="bio" name="bio" value={formData.bio} onChange={handleChange} rows={4} className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-2 text-gray-800 focus:ring-2 focus:ring-[#376770]/20 focus:border-[#376770] focus:outline-none" placeholder="Racconta qualcosa di te e della tua esperienza..." data-id="element-832"></textarea>
                  </div>
                </div>
              </div>
            </div>}
          {/* Step 3: Social Media */}
          {currentStep === 3 && <div className="flex-1 flex flex-col" data-id="element-833">
              <div className="text-center mb-8" data-id="element-834">
                <h2 className="text-2xl font-bold text-white mb-2" data-id="element-835">
                  Canali social
                </h2>
                <p className="text-gray-300" data-id="element-836">
                  Collega i tuoi profili social per condividere i tuoi contenuti
                </p>
              </div>
              <div className="bg-white rounded-lg p-6 mb-6 shadow-lg" data-id="element-837">
                <div className="space-y-4" data-id="element-838">
                  <SocialInput icon={<Instagram className="text-pink-400" data-id="element-840" />} name="instagram" value={formData.instagram} onChange={handleChange} placeholder="Username Instagram" data-id="element-839" />
                  <SocialInput icon={<Twitter className="text-blue-400" data-id="element-842" />} name="twitter" value={formData.twitter} onChange={handleChange} placeholder="Username Twitter" data-id="element-841" />
                  <SocialInput icon={<Facebook className="text-blue-600" data-id="element-844" />} name="facebook" value={formData.facebook} onChange={handleChange} placeholder="Username Facebook" data-id="element-843" />
                  <SocialInput icon={<Youtube className="text-red-500" data-id="element-846" />} name="youtube" value={formData.youtube} onChange={handleChange} placeholder="Username YouTube" data-id="element-845" />
                </div>
                <div className="mt-6 p-4 bg-gray-50 rounded-md" data-id="element-847">
                  <div className="flex items-start" data-id="element-848">
                    <div className="flex-shrink-0 mt-0.5" data-id="element-849">
                      <Upload size={18} className="text-gray-500" data-id="element-850" />
                    </div>
                    <div className="ml-3" data-id="element-851">
                      <h4 className="text-sm font-medium text-gray-800" data-id="element-852">
                        Importa automaticamente i tuoi post
                      </h4>
                      <p className="mt-1 text-xs text-gray-500" data-id="element-853">
                        Collegando i tuoi profili social, potrai importare
                        automaticamente i tuoi post e condividerli con la
                        community di Elze.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
          {/* Step 4: Carica Opera */}
          {currentStep === 4 && <div className="flex-1 flex flex-col" data-id="element-854">
              <div className="text-center mb-8" data-id="element-855">
                <h2 className="text-2xl font-bold text-white mb-2" data-id="element-856">
                  Carica Opera
                </h2>
                <p className="text-gray-300" data-id="element-857">
                  Carica la tua prima opera su Elze
                </p>
                {/* Minimal sub-step indicator */}
                <div className="mt-4" data-id="element-858">
                  <span className="inline-block px-3 py-1 bg-[#7F9EA4]/50 rounded-md text-white text-sm" data-id="element-859">
                    {uploadSubStep} di 3
                    <span className="ml-2 text-xs text-gray-300" data-id="element-860">
                      {uploadSubStep === 1 ? 'Caricamento' : uploadSubStep === 2 ? 'Informazioni' : 'Dichiarazione'}
                    </span>
                  </span>
                </div>
              </div>
              <div className="bg-white rounded-lg p-6 mb-6 shadow-lg" data-id="element-861">
                {/* Sub-step 1: Caricamento file */}
                {uploadSubStep === 1 && <div data-id="element-862">
                    <h3 className="text-lg font-semibold text-[#164149] mb-4" data-id="element-863">
                      Carica il tuo manoscritto
                    </h3>
                    <div className="space-y-6" data-id="element-864">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-865">
                        <UploadMethodCard icon={<FileUp size={32} data-id="element-867" />} title="Carica file" description="Carica un file PDF, TXT o DOCX direttamente dal tuo computer" selected={formData.uploadMethod === 'file'} onClick={() => handleUploadMethodSelect('file')} data-id="element-866" />
                        <UploadMethodCard icon={<Tablet size={32} data-id="element-869" />} title="Integrazione" description="Importa la tua opera da Amazon Kindle o altre piattaforme" selected={formData.uploadMethod === 'integration'} onClick={() => handleUploadMethodSelect('integration')} data-id="element-868" />
                      </div>
                      {formData.uploadMethod === 'file' && <div className="mt-6" data-id="element-870">
                          <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center" data-id="element-871">
                            {formData.bookFile ? <div className="flex flex-col items-center" data-id="element-872">
                                <FileText size={48} className="text-[#376770] mb-2" data-id="element-873" />
                                <p className="text-gray-800 font-medium" data-id="element-874">
                                  {formData.bookFile.name}
                                </p>
                                <p className="text-gray-500 text-sm" data-id="element-875">
                                  {(formData.bookFile.size / 1024 / 1024).toFixed(2)}{' '}
                                  MB
                                </p>
                                <button className="mt-3 px-3 py-1 bg-gray-100 text-gray-700 rounded-md text-sm hover:bg-gray-200 transition-colors" onClick={() => setFormData(prev => ({
                        ...prev,
                        bookFile: null
                      }))} data-id="element-876">
                                  Cambia file
                                </button>
                              </div> : <>
                                <File size={48} className="text-gray-400 mx-auto mb-3" data-id="element-877" />
                                <p className="text-gray-600 mb-2" data-id="element-878">
                                  Trascina il file qui o
                                </p>
                                <label htmlFor="book-file" className="px-4 py-2 bg-[#376770] text-white rounded-md cursor-pointer hover:bg-[#164149] transition-colors inline-block" data-id="element-879">
                                  Seleziona file
                                </label>
                                <input type="file" id="book-file" className="hidden" accept=".pdf,.txt,.docx" onChange={handleBookFileUpload} data-id="element-880" />
                                <p className="text-gray-500 text-sm mt-2" data-id="element-881">
                                  Formati supportati: PDF, TXT, DOCX
                                </p>
                              </>}
                          </div>
                        </div>}
                      {formData.uploadMethod === 'integration' && <div className="mt-6" data-id="element-882">
                          <div className="space-y-4" data-id="element-883">
                            <div className="p-4 border border-gray-200 rounded-lg flex items-center" data-id="element-884">
                              <div size={32} className="text-[#ff9900] mr-4" data-id="element-885" />
                              <div className="flex-1" data-id="element-886">
                                <h4 className="text-gray-800 font-medium" data-id="element-887">
                                  Amazon Kindle
                                </h4>
                                <p className="text-gray-500 text-sm" data-id="element-888">
                                  Collega il tuo account Amazon per importare le
                                  tue opere
                                </p>
                              </div>
                              <button className="px-4 py-2 bg-[#376770] text-white rounded-md hover:bg-[#164149] transition-colors" data-id="element-889">
                                Collega
                              </button>
                            </div>
                            <div className="p-4 border border-gray-200 rounded-lg flex items-center" data-id="element-890">
                              <Book size={32} className="text-blue-500 mr-4" data-id="element-891" />
                              <div className="flex-1" data-id="element-892">
                                <h4 className="text-gray-800 font-medium" data-id="element-893">
                                  Apple Books
                                </h4>
                                <p className="text-gray-500 text-sm" data-id="element-894">
                                  Collega il tuo account Apple Books per
                                  importare le tue opere
                                </p>
                              </div>
                              <button className="px-4 py-2 bg-[#376770] text-white rounded-md hover:bg-[#164149] transition-colors" data-id="element-895">
                                Collega
                              </button>
                            </div>
                            <div className="p-4 border border-gray-200 rounded-lg flex items-center" data-id="element-896">
                              <FileType size={32} className="text-purple-500 mr-4" data-id="element-897" />
                              <div className="flex-1" data-id="element-898">
                                <h4 className="text-gray-800 font-medium" data-id="element-899">
                                  Altra piattaforma
                                </h4>
                                <p className="text-gray-500 text-sm" data-id="element-900">
                                  Importa le tue opere da un'altra piattaforma
                                </p>
                              </div>
                              <button className="px-4 py-2 bg-[#376770] text-white rounded-md hover:bg-[#164149] transition-colors" data-id="element-901">
                                Importa
                              </button>
                            </div>
                          </div>
                        </div>}
                    </div>
                  </div>}
                {/* Sub-step 2: Informazioni Opera */}
                {uploadSubStep === 2 && <div data-id="element-902">
                    <h3 className="text-lg font-semibold text-[#164149] mb-4" data-id="element-903">
                      Inserisci le informazioni sull'opera
                    </h3>
                    <div className="space-y-4" data-id="element-904">
                      <div className="flex flex-col sm:flex-row items-center gap-6 mb-6" data-id="element-905">
                        <div className="relative" data-id="element-906">
                          <div className="w-32 h-48 bg-gray-100 flex items-center justify-center overflow-hidden rounded-md border border-gray-200" data-id="element-907">
                            {formData.bookCover ? <img src={formData.bookCover} alt="Book Cover" className="w-full h-full object-cover" data-id="element-908" /> : <BookOpen size={40} className="text-gray-400" data-id="element-909" />}
                          </div>
                          <label htmlFor="book-cover" className="absolute bottom-2 right-2 w-8 h-8 bg-[#376770] rounded-full flex items-center justify-center cursor-pointer border border-[#7F9EA4] hover:bg-[#164149] transition-colors" data-id="element-910">
                            <Camera size={16} className="text-white" data-id="element-911" />
                          </label>
                          <input type="file" id="book-cover" className="hidden" accept="image/*" onChange={handleBookCoverUpload} data-id="element-912" />
                        </div>
                        <div className="flex-1" data-id="element-913">
                          <h3 className="text-gray-800 font-medium mb-1" data-id="element-914">
                            Copertina dell'opera
                          </h3>
                          <p className="text-gray-500 text-sm" data-id="element-915">
                            Carica un'immagine di copertina per la tua opera.
                            Consigliamo un formato 2:3.
                          </p>
                        </div>
                      </div>
                      <div data-id="element-916">
                        <label htmlFor="bookTitle" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-917">
                          Titolo dell'opera *
                        </label>
                        <input type="text" id="bookTitle" name="bookTitle" value={formData.bookTitle} onChange={handleChange} className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-2 text-gray-800 focus:ring-2 focus:ring-[#376770]/20 focus:border-[#376770] focus:outline-none" placeholder="Inserisci il titolo dell'opera" required data-id="element-918" />
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-919">
                        <div data-id="element-920">
                          <label htmlFor="bookPages" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-921">
                            Numero di pagine
                          </label>
                          <input type="number" id="bookPages" name="bookPages" value={formData.bookPages} onChange={handleChange} className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-2 text-gray-800 focus:ring-2 focus:ring-[#376770]/20 focus:border-[#376770] focus:outline-none" placeholder="Es. 250" data-id="element-922" />
                        </div>
                        <div data-id="element-923">
                          <label htmlFor="bookGenre" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-924">
                            Genere *
                          </label>
                          <select id="bookGenre" name="bookGenre" value={formData.bookGenre} onChange={handleChange} className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-2 text-gray-800 focus:ring-2 focus:ring-[#376770]/20 focus:border-[#376770] focus:outline-none" required data-id="element-925">
                            <option value="" data-id="element-926">Seleziona un genere</option>
                            <option value="Romanzo" data-id="element-927">Romanzo</option>
                            <option value="Poesia" data-id="element-928">Poesia</option>
                            <option value="Saggistica" data-id="element-929">Saggistica</option>
                            <option value="Thriller" data-id="element-930">Thriller</option>
                            <option value="Fantasy" data-id="element-931">Fantasy</option>
                            <option value="Fantascienza" data-id="element-932">Fantascienza</option>
                            <option value="Horror" data-id="element-933">Horror</option>
                            <option value="Giallo" data-id="element-934">Giallo</option>
                            <option value="Biografia" data-id="element-935">Biografia</option>
                            <option value="Storia" data-id="element-936">Storia</option>
                            <option value="Altro" data-id="element-937">Altro</option>
                          </select>
                        </div>
                      </div>
                      <div data-id="element-938">
                        <label htmlFor="bookDescription" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-939">
                          Trama/Descrizione *
                        </label>
                        <textarea id="bookDescription" name="bookDescription" value={formData.bookDescription} onChange={handleChange} rows={5} className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-2 text-gray-800 focus:ring-2 focus:ring-[#376770]/20 focus:border-[#376770] focus:outline-none" placeholder="Inserisci una breve descrizione o la trama dell'opera..." required data-id="element-940"></textarea>
                      </div>
                    </div>
                  </div>}
                {/* Sub-step 3: Dichiarazione originalità */}
                {uploadSubStep === 3 && <div data-id="element-941">
                    <h3 className="text-lg font-semibold text-[#164149] mb-4" data-id="element-942">
                      Dichiarazione di originalità e paternità
                    </h3>
                    <div className="space-y-6" data-id="element-943">
                      <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg" data-id="element-944">
                        <div className="flex items-start" data-id="element-945">
                          <Info size={20} className="text-blue-500 mt-0.5 mr-3 flex-shrink-0" data-id="element-946" />
                          <p className="text-sm text-blue-800" data-id="element-947">
                            Prima di procedere, è necessario dichiarare che
                            l'opera caricata è di tua proprietà e che sei
                            l'autore originale o hai i diritti necessari per
                            pubblicarla.
                          </p>
                        </div>
                      </div>
                      <div className="p-5 border border-gray-200 rounded-lg" data-id="element-948">
                        <div className="flex items-start mb-6" data-id="element-949">
                          <input type="checkbox" id="originalityDeclaration" name="originalityDeclaration" checked={formData.originalityDeclaration} onChange={handleChange} className="mt-1 h-4 w-4 text-[#376770] focus:ring-[#376770] border-gray-300 rounded" required data-id="element-950" />
                          <label htmlFor="originalityDeclaration" className="ml-3 text-sm text-gray-700" data-id="element-951">
                            <span className="font-medium" data-id="element-952">
                              Dichiaro sotto la mia responsabilità
                            </span>{' '}
                            che l'opera caricata è di mia proprietà e che sono
                            l'autore originale o ho ottenuto tutti i diritti
                            necessari per la sua pubblicazione. Comprendo che
                            dichiarazioni false possono comportare la rimozione
                            dell'opera e conseguenze legali.
                          </label>
                        </div>
                        <h4 className="text-base font-medium text-[#164149] mb-3" data-id="element-953">
                          Utilizzo di Intelligenza Artificiale
                        </h4>
                        <div className="space-y-4" data-id="element-954">
                          <div className="flex items-start" data-id="element-955">
                            <input type="checkbox" id="aiUsed" name="aiUsed" checked={formData.aiUsed} onChange={handleChange} className="mt-1 h-4 w-4 text-[#376770] focus:ring-[#376770] border-gray-300 rounded" data-id="element-956" />
                            <label htmlFor="aiUsed" className="ml-3 text-sm text-gray-700" data-id="element-957">
                              Ho utilizzato strumenti di Intelligenza
                              Artificiale nella creazione di questa opera
                            </label>
                          </div>
                          {formData.aiUsed && <div className="ml-7 space-y-4 p-4 bg-gray-50 rounded-md" data-id="element-958">
                              <div data-id="element-959">
                                <label htmlFor="aiType" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-960">
                                  Quale strumento AI hai utilizzato?
                                </label>
                                <input type="text" id="aiType" name="aiType" value={formData.aiType} onChange={handleChange} className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 text-gray-800 focus:ring-2 focus:ring-[#376770]/20 focus:border-[#376770] focus:outline-none" placeholder="Es. ChatGPT, Midjourney, DALL-E" data-id="element-961" />
                              </div>
                              <div data-id="element-962">
                                <label htmlFor="aiPercentage" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-963">
                                  In che misura hai utilizzato l'AI? (%)
                                </label>
                                <select id="aiPercentage" name="aiPercentage" value={formData.aiPercentage} onChange={handleChange} className="w-full bg-white border border-gray-300 rounded-md px-4 py-2 text-gray-800 focus:ring-2 focus:ring-[#376770]/20 focus:border-[#376770] focus:outline-none" data-id="element-964">
                                  <option value="" data-id="element-965">
                                    Seleziona una percentuale
                                  </option>
                                  <option value="meno del 10%" data-id="element-966">
                                    Meno del 10% - Solo per idee o ispirazione
                                  </option>
                                  <option value="10-30%" data-id="element-967">
                                    10-30% - Per alcune parti o sezioni
                                  </option>
                                  <option value="30-50%" data-id="element-968">
                                    30-50% - Per molte parti dell'opera
                                  </option>
                                  <option value="50-70%" data-id="element-969">
                                    50-70% - Per la maggior parte dell'opera
                                  </option>
                                  <option value="più del 70%" data-id="element-970">
                                    Più del 70% - L'opera è prevalentemente
                                    generata dall'AI
                                  </option>
                                </select>
                              </div>
                            </div>}
                        </div>
                      </div>
                      <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg" data-id="element-971">
                        <div className="flex items-start" data-id="element-972">
                          <AlertCircle size={20} className="text-yellow-500 mt-0.5 mr-3 flex-shrink-0" data-id="element-973" />
                          <p className="text-sm text-yellow-800" data-id="element-974">
                            Nota: Le opere create con l'ausilio di strumenti di
                            Intelligenza Artificiale potrebbero essere soggette
                            a politiche specifiche relative ai diritti d'autore.
                            Elze si impegna a proteggere i diritti degli autori
                            in conformità con le normative vigenti.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>}
              </div>
            </div>}
        </div>
      </div>
      {/* Sticky Navigation Footer */}
      <div className="fixed bottom-0 left-0 right-0 bg-[#376770] border-t border-[#7F9EA4]/50 py-4 px-4 sm:px-6 lg:px-8 shadow-lg" data-id="element-975">
        <div className="flex justify-between items-center" data-id="element-976">
          {currentStep > 1 || currentStep === 4 && uploadSubStep > 1 ? <button onClick={prevStep} className="flex items-center px-4 py-2 bg-[#7F9EA4]/50 text-white rounded-md hover:bg-[#7F9EA4]/70 transition-colors" data-id="element-977">
              <ChevronLeft size={16} className="mr-2" data-id="element-978" />
              Indietro
            </button> : <div data-id="element-979"></div>}
          <button onClick={nextStep} disabled={!isStepValid()} className={`flex items-center px-4 py-2 rounded-md transition-colors ${isStepValid() ? 'bg-[#C6D6AB] text-gray-800 hover:bg-[#b8c99a]' : 'bg-gray-500/30 text-gray-400 cursor-not-allowed'}`} data-id="element-980">
            {currentStep === 4 && uploadSubStep === 3 ? 'Vai alla Dashboard' : <>
                Continua
                <ChevronRight size={16} className="ml-2" data-id="element-981" />
              </>}
          </button>
        </div>
      </div>
    </div>;
}
// Step Indicator Component
function StepIndicator({
  number,
  title,
  active,
  completed
}) {
  return <div className="flex flex-col items-center mx-1" data-id="element-982">
      <div className={`w-7 h-7 rounded-full flex items-center justify-center ${completed ? 'bg-[#C6D6AB] text-gray-800' : active ? 'bg-[#7F9EA4] text-white' : 'bg-[#7F9EA4]/50 text-gray-300'}`} data-id="element-983">
        {completed ? <Check size={14} data-id="element-984" /> : number}
      </div>
      <div className={`text-xs mt-1 ${active || completed ? 'text-white' : 'text-gray-400'}`} data-id="element-985">
        {title}
      </div>
    </div>;
}
// Role Card Component
function RoleCard({
  icon,
  title,
  description,
  selected,
  onClick
}) {
  return <div className={`p-6 rounded-lg cursor-pointer transition-all ${selected ? 'bg-white text-[#164149] ring-2 ring-[#376770] shadow-md' : 'bg-gray-50 text-gray-800 hover:bg-gray-100'}`} onClick={onClick} data-id="element-986">
      <div className="flex items-center mb-4" data-id="element-987">
        <div className={`p-2 rounded-full ${selected ? 'bg-[#EFF2F1]' : 'bg-[#EFF2F1]'}`} data-id="element-988">
          {icon}
        </div>
        <div className="ml-4 flex-1" data-id="element-989">
          <h3 className="text-lg font-semibold" data-id="element-990">{title}</h3>
        </div>
        {selected && <div className="w-6 h-6 bg-[#376770] rounded-full flex items-center justify-center" data-id="element-991">
            <Check size={14} className="text-white" data-id="element-992" />
          </div>}
      </div>
      <p className={`text-sm ${selected ? 'text-gray-700' : 'text-gray-600'}`} data-id="element-993">
        {description}
      </p>
    </div>;
}
// Upload Method Card Component
function UploadMethodCard({
  icon,
  title,
  description,
  selected,
  onClick
}) {
  return <div className={`p-6 rounded-lg cursor-pointer transition-all ${selected ? 'bg-white text-[#164149] ring-2 ring-[#376770] shadow-md' : 'bg-gray-50 text-gray-800 hover:bg-gray-100'}`} onClick={onClick} data-id="element-994">
      <div className="flex items-center mb-4" data-id="element-995">
        <div className={`p-2 rounded-full ${selected ? 'bg-[#EFF2F1]' : 'bg-[#EFF2F1]'}`} data-id="element-996">
          {icon}
        </div>
        <div className="ml-4 flex-1" data-id="element-997">
          <h3 className="text-lg font-semibold" data-id="element-998">{title}</h3>
        </div>
        {selected && <div className="w-6 h-6 bg-[#376770] rounded-full flex items-center justify-center" data-id="element-999">
            <Check size={14} className="text-white" data-id="element-1000" />
          </div>}
      </div>
      <p className={`text-sm ${selected ? 'text-gray-700' : 'text-gray-600'}`} data-id="element-1001">
        {description}
      </p>
    </div>;
}
// Social Input Component
function SocialInput({
  icon,
  name,
  value,
  onChange,
  placeholder
}) {
  return <div className="flex items-center" data-id="element-1002">
      <div className="w-10 flex-shrink-0 flex items-center justify-center" data-id="element-1003">
        {icon}
      </div>
      <input type="text" name={name} value={value} onChange={onChange} className="flex-1 bg-gray-50 border border-gray-300 rounded-md px-4 py-2 text-gray-800 focus:ring-2 focus:ring-[#376770]/20 focus:border-[#376770] focus:outline-none ml-2" placeholder={placeholder} data-id="element-1004" />
    </div>;
}
// Feature Card Component
function FeatureCard({
  icon,
  title,
  description
}) {
  return <div className="bg-gray-50 p-4 rounded-lg" data-id="element-1005">
      <div className="flex items-start" data-id="element-1006">
        <div className="p-2 bg-[#EFF2F1] rounded-full text-[#376770]" data-id="element-1007">
          {icon}
        </div>
        <div className="ml-3" data-id="element-1008">
          <h4 className="text-gray-800 font-medium" data-id="element-1009">{title}</h4>
          <p className="text-gray-600 text-sm mt-1" data-id="element-1010">{description}</p>
        </div>
      </div>
    </div>;
}